module.exports = __webpack_public_path__ + "img/nav-theme-dark.f6d512ec.svg";